import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_or0vvyanpz: FaireBrandEntity = {
  token: "b_or0vvyanpz",
  type: "brand",
  name: "My Spa Life",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5c38d8b571c7e87453a60f42969b85ab4e4e59cf8368bce4fe250b9a6e610c6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/41ae26ad643acfd4154ebb2f3833cd36dfd9def137ebbea71da80df74353fe12.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a5c38d8b571c7e87453a60f42969b85ab4e4e59cf8368bce4fe250b9a6e610c6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/41ae26ad643acfd4154ebb2f3833cd36dfd9def137ebbea71da80df74353fe12.jpeg",
  location: "Edison, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 402,
  isInsider: true,
  description:
    'SpaLife was founded on the simple idea that everyone deserves to indulge in quality at-home treatments and feel-good “me-moments”. \nFrom single-use foot treatments to facial serums and pimple patches, our products are thoughtfully formulated to deliver unexpectedly fun and sensorial experiences at an accessible price point.\n\nSpaLife focuses on selling Health & Beauty products such as facial mask, foot masks, and hand gloves. We also offer other products such as serums, gift sets, & more! \n\nSpaLife is the unapologetically fun and affordable skincare company that champions self-care, self-empowerment, and creating little moments of joy in the everyday.\n\n* All SpaLife facial masks, eye masks, hand and foot products, and serums feature natural extracts as hero ingredients, but are not certified all-natural or organic. \n"We like our furry friends and do not perform animal testing.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:16.748Z",
    importedBy: "entity-db-cli",
  },
};
